export default __webpack_public_path__ + "static/media/community_updated_icon.cc24fc6b.gif";